module.exports = __webpack_public_path__ + "img/nature@2x.12b5cfd.webp";